import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, LogIn } from 'lucide-react';

interface NavigationProps {
  variant?: 'default' | 'transparent';
}

const Navigation: React.FC<NavigationProps> = ({ variant = 'default' }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const navbarClasses = variant === 'transparent' 
    ? "fixed top-0 left-0 right-0 z-30 py-5 bg-transparent" 
    : "fixed top-0 left-0 right-0 z-30 py-4 bg-black/80 backdrop-blur-md shadow-sm border-b border-gray-800";

  return (
    <header className={navbarClasses}>
      <div className="container flex items-center justify-between">
        {/* Logo - PayorPlay.club */}
        <Link to="/" className="flex flex-col items-start hover:opacity-80 transition-opacity">
          <span className="text-white text-2xl font-bold leading-tight">
            PayorPlay.club
          </span>
          <span className="text-white text-xs font-normal leading-tight mt-0.5">
            Powered by Nuclius
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <Link to="/" className="text-white/80 hover:text-white text-sm font-medium">
            Home
          </Link>
          <Link to="/#features" className="text-white/80 hover:text-white text-sm font-medium">
            Features
          </Link>
          <Link to="/pricing" className="text-white/80 hover:text-white text-sm font-medium">
            Pricing
          </Link>
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center space-x-4">
          <Button asChild variant="ghost" size="sm">
            <Link to="/login" className="flex items-center gap-1 text-white">
              <LogIn className="h-4 w-4 mr-1" />
              Sign In
            </Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/register">Get Started</Link>
          </Button>
        </div>

        {/* Mobile Navigation Toggle */}
        <button
          className="md:hidden p-2 rounded-full hover:bg-white/10 transition-colors text-white"
          onClick={toggleMobileMenu}
        >
          {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md shadow-md p-4 border-t border-gray-700 z-20">
          <nav className="flex flex-col space-y-2 mb-4">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-white hover:bg-white/10 rounded-md" onClick={closeMobileMenu}>
              Home
            </Link>
            <Link to="/#features" className="px-3 py-2 text-sm font-medium text-white hover:bg-white/10 rounded-md" onClick={closeMobileMenu}>
              Features
            </Link>
            <Link to="/pricing" className="px-3 py-2 text-sm font-medium text-white hover:bg-white/10 rounded-md" onClick={closeMobileMenu}>
              Pricing
            </Link>
          </nav>
          <div className="grid grid-cols-2 gap-2">
            <Button asChild variant="outline" size="sm">
              <Link to="/login" onClick={closeMobileMenu}>Sign In</Link>
            </Button>
            <Button asChild size="sm">
              <Link to="/register" onClick={closeMobileMenu}>Get Started</Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation; 